import ShareIcons from "Pages/components/ShareIcons";
import Enquire from "Pages/Enquire/Enquire";
import React from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import { COLORS, SIZES, WEIGHT } from "theme";

const ContactUsInfo = ({ data, small, medium }) => {
  return (
    <Box
      textAlign="center"
      display="flex"
      flexDirection="column"
      padding={
        small
          ? SIZES.forty
          : `${SIZES.eighty} ${SIZES.eighty} 300px ${SIZES.eighty}  `
      }
      background={COLORS.lightBlack}
    >
      <Box w={small ? "100%" : "530px"} textAlign="left">
        <Text
          textColor={COLORS.white}
          lineHeight="1.5"
          fontWeight={WEIGHT.regular}
          fontSize={small ? SIZES.twentyFour : SIZES.forty}
          margin="0"
        >
          {data[0]?.attributes?.title}
        </Text>
        <ShareIcons
          height={small ? "30px" : "64px"}
          marginRight={small ? "12px" : "36px"}
          small={small}
          marginTop={SIZES.sixty}
        />
      </Box>
      <Enquire noModal small={small} medium={medium} />
    </Box>
  );
};

export default ContactUsInfo;
